/**
 * Application Call to Action
 *
 * Derived from the application status so every entry point on the site shows the
 * same label and the same date, formatted with the same helper as the header.
 */

import { SEASON_CONFIG } from './core';
import { formatDate } from '../../utils/date';

export const APPLY_CTA = {
  isOpen: SEASON_CONFIG.application.status.isOpen,
  label: SEASON_CONFIG.application.status.isOpen
    ? 'Apply Now'
    : `Applications open ${formatDate(SEASON_CONFIG.application.deadlines.start, 'MMMM dd, yyyy')}`,
  infoLabel: SEASON_CONFIG.application.status.isOpen ? 'Apply Now' : 'How to Apply',
  infoUrl: '/the-institute/online-application',
  formUrl: '/account/application'
} as const;
